/* Heart of Ma · theatrical motion v2.0; dependency-free progressive enhancement */
(function(){
 'use strict';
 const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
 const sectionObserver=('IntersectionObserver' in window)?new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('hma--section-seen');window.setTimeout(()=>e.target.querySelectorAll('[data-hma-reveal]').forEach(el=>el.classList.add('hma--visible')),90);sectionObserver.unobserve(e.target)}})
 },{threshold:.13,rootMargin:'0px 0px -6% 0px'}):null;
 const revealObserver=('IntersectionObserver' in window)?new IntersectionObserver(entries=>{
  entries.forEach(e=>{if(e.isIntersecting){e.target.classList.add('hma--visible');revealObserver.unobserve(e.target)}})
 },{threshold:.12,rootMargin:'0px 0px -20px 0px'}):null;
 function sections(root){const result=[]; if(root.matches&&root.matches('.hma'))result.push(root);result.push(...root.querySelectorAll('.hma'));return result;}
 function init(root){sections(root).forEach(section=>{
  if(section.dataset.hmaInit==='yes')return;
  section.dataset.hmaInit='yes';
  const revealEls=section.querySelectorAll('[data-hma-reveal]');
  if(!motion.matches&&revealObserver){section.classList.add('hma--motion');revealEls.forEach(el=>revealObserver.observe(el)); if(sectionObserver)sectionObserver.observe(section);}
  else{section.classList.add('hma--section-seen');revealEls.forEach(el=>el.classList.add('hma--visible'));}
  const rail=section.querySelector('[data-hma-carousel]');
  if(rail)section.querySelectorAll('[data-hma-slide]').forEach(btn=>btn.addEventListener('click',()=>{
   const card=rail.querySelector('.hma-products__item');if(!card)return;
   const gap=parseFloat(window.getComputedStyle(rail).columnGap)||0;
   rail.scrollBy({left:(card.getBoundingClientRect().width+gap)*(btn.dataset.hmaSlide==='next'?1:-1),behavior:motion.matches?'instant':'smooth'});
  }));
  if(section.classList.contains('hma-hero'))initHeroParallax(section);
 });}
 function initHeroParallax(hero){
  if(motion.matches)return;
  const art=hero.querySelector('.hma-hero__art');if(!art)return;
  hero.addEventListener('pointermove',e=>{if(e.pointerType==='touch')return;
   const r=art.getBoundingClientRect(); const x=Math.max(-1,Math.min(1,(e.clientX-(r.left+r.width/2))/r.width))*23;
   const y=Math.max(-1,Math.min(1,(e.clientY-(r.top+r.height/2))/r.height))*21;
   art.style.setProperty('--hma-pointer-x',x.toFixed(2)+'px');art.style.setProperty('--hma-pointer-y',y.toFixed(2)+'px');
  },{passive:true});
  hero.addEventListener('pointerleave',()=>{art.style.setProperty('--hma-pointer-x','0px');art.style.setProperty('--hma-pointer-y','0px')},{passive:true});
  let queued=false;
  const onScroll=()=>{if(queued)return;queued=true;window.requestAnimationFrame(()=>{
   const r=hero.getBoundingClientRect();if(r.bottom>0&&r.top<window.innerHeight){const delta=Math.max(-100,Math.min(140,-r.top*.16));art.style.setProperty('--hma-depth',delta.toFixed(1)+'px');}
   queued=false;
  });};
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
 document.addEventListener('shopify:section:load',e=>init(e.target));
 document.addEventListener('shopify:section:select',e=>{sections(e.target).forEach(s=>{s.classList.add('hma--section-seen');s.querySelectorAll('[data-hma-reveal]').forEach(el=>el.classList.add('hma--visible'));});});
 motion.addEventListener('change',()=>{document.querySelectorAll('.hma').forEach(s=>{s.classList.add('hma--section-seen');s.querySelectorAll('[data-hma-reveal]').forEach(el=>el.classList.add('hma--visible'));});});
 window.hmaReplayEntrance=function(){const hero=document.querySelector('.hma-hero');if(!hero||motion.matches)return false;
  window.scrollTo({top:0,behavior:'instant'});
  const els=hero.querySelectorAll('[data-hma-reveal]');
  els.forEach(el=>{el.classList.remove('hma--visible');if(revealObserver)revealObserver.unobserve(el)});
  hero.classList.add('hma--section-seen');
  window.setTimeout(()=>els.forEach(el=>el.classList.add('hma--visible')),230);
  return true;
 };
})();